export default __webpack_public_path__ + "static/media/magiceden_logo224.eabf5c18.png";